import {Route} from '@angular/router';
import {AuthentificationBeforeComponent} from './authentification-before.component';

export const authentificationBeforeRoute: Route = {
    path: 'authentification',
    pathMatch: 'full',
    title: 'authentication.before.title',
    component: AuthentificationBeforeComponent,
};
